module.exports = __webpack_public_path__ + "static/media/ic_copy_planning.ec2e7dbe.svg";